var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tem-all"},[_c(_vm.currentComponent,{tag:"component",attrs:{"temData":_vm.temData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }